var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Head',{attrs:{"showBorder":4}}),_vm._v(" "),_c('img',{staticClass:"contact1",attrs:{"src":require("../assets/contact1.jpg"),"alt":""}}),_vm._v(" "),_c('img',{staticClass:"mapImg",attrs:{"src":require("../assets/mapImg.jpg"),"alt":""}}),_vm._v(" "),_c('Bottom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1371054f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/contact.vue
// module id = null
// module chunks = 